import cn from 'clsx';
import type { FC, ReactNode } from 'react';

import { ColorPalette, IconType, TextButtonStateType } from '../../../types';
import IconButton from '../../Button/Icon/IconButton';
import TextButton from '../../Button/Text/TextButton';
import Icon from '../../Icon';

import s from './BasicTopNavigation.module.scss';

type BasicTopNavigationLeftType = 'back' | 'close' | 'bznav-refund-logo';

interface BasicTopNavigationRightIconModel {
  icon: IconType;
  color?: ColorPalette;
  onClick: () => void;
}

interface BasicTopNavigationRightTextButtonModel {
  label: string;
  state?: TextButtonStateType;
  onClick: () => void;
  disabled?: boolean;
}

export interface BasicTopNavigationProps {
  className?: string;
  leftIcon?: BasicTopNavigationLeftType;
  leftIconColor?: ColorPalette;
  title?: ReactNode;
  rightIcons?: BasicTopNavigationRightIconModel[];
  rightTextButton?: BasicTopNavigationRightTextButtonModel;
  border?: boolean;
  isExpandable?: boolean;
  onExpandClick?: () => void;
  onLeftClick?: (e?: any) => void;
}

const BasicTopNavigation: FC<React.PropsWithChildren<React.PropsWithChildren<BasicTopNavigationProps>>> = ({
  border = false,
  isExpandable = false,
  leftIconColor = 'gray.800',
  leftIcon,
  title,
  rightIcons,
  rightTextButton,
  onExpandClick,
  onLeftClick,
  className
}) => {
  return (
    <header
      className={cn(
        s.wrap,
        {
          [s.border as string]: border
        },
        className
      )}
    >
      <div className={s.inner_wrap}>
        <div className={cn(s.left, s.fixed_width, s.center)}>
          {leftIcon && (
            <IconButton
              icon={leftIcon === 'back' ? 'arrow-left' : leftIcon}
              color={leftIconColor || 'gray.800'}
              className={cn({ 'ml-4 justify-start': leftIcon === 'bznav-refund-logo' })}
              onClick={onLeftClick}
            />
          )}
        </div>

        <div className={cn(s.title, s.center)}>
          {isExpandable ? (
            <button className={cn(s.titleButton)} type="button" onClick={onExpandClick}>
              <span className={s.titleText}>{title}</span>
              <Icon type="expand-more" color="gray.800" size={24} />
            </button>
          ) : (
            <span className={s.titleText}>{title}</span>
          )}
        </div>

        <div className={cn(s.right, s.fixed_width, s.center)}>
          {rightIcons?.map((item) => (
            <IconButton key={item.icon} color={item.color || 'gray.800'} icon={item.icon} onClick={item.onClick} />
          ))}
          {rightTextButton && (
            <TextButton
              className={s.text_button}
              state={rightTextButton.state || 'gray'}
              size="large"
              onClick={rightTextButton.onClick}
              disabled={rightTextButton.disabled}
            >
              {rightTextButton.label}
            </TextButton>
          )}
        </div>
      </div>
    </header>
  );
};

export default BasicTopNavigation;
